import { ModelBase } from "@singularsystems/neo-core";

export default abstract class APIModelBase extends ModelBase {

}